import './audio.css'
import muteIcon from '../../assets/mute.svg';
import unmuteIcon from '../../assets/unmute.svg';
import music from '../../assets/audio/song.mp3';
import { useState, useEffect, useRef } from 'react';

const Audio = () => {

    const [isMuted, setIsMuted] = useState(true);
    const audioRef = useRef(null);

    const handleAudioToggle = () => {
        setIsMuted(!isMuted);
    };

    useEffect(() => {
        const startAudio = () => {
            audioRef.current.play();
            setIsMuted(false);
            window.removeEventListener('click', startAudio);
        };

        window.addEventListener('click', startAudio);

        return () => {
            window.removeEventListener('click', startAudio);
        };
    }, []);

    return (
        <>
            <audio ref={audioRef} loop muted={isMuted}>
                <source src={music} type="audio/mpeg" />
            </audio>

            <button className='audioBtn' onClick={handleAudioToggle}>
                <img 
                    src={isMuted ? muteIcon : unmuteIcon}
                    alt="audio toggle"
                />
            </button>
        </>
    );
}

export default Audio;